export default "__VITE_ASSET__CcqNNpDV__"